import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { Error404Component } from '../../errors/404/error-404.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { GenericAlertComponent } from '../../../../gt2/components/generic-alert/generic-alert.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FuseDirectivesModule } from '../../../../../@fuse/directives/directives';
import { FusePipesModule } from '../../../../../@fuse/pipes/pipes.module';
import { AppRoutesName } from '../../../../gt2/const/AppRoutesName';

const routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.ERROR_404,
    component: Error404Component,
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.ERROR_404,
    component: Error404Component,
  },
  {
    path: AppRoutesName.EN.ERROR_404,
    component: Error404Component,
  },
  {
    path: AppRoutesName.FR.ERROR_404,
    component: Error404Component,
  },
];

@NgModule({
  declarations: [Error404Component],
  imports: [
    MatFormFieldModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    GenericAlertComponent,
    TranslateModule.forRoot(),
    RouterModule.forChild(routes),
    MatIconModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FuseDirectivesModule,
    FusePipesModule,
  ],
})
export class Error404Module {}
